import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { getClientConfiguration } from "../../configuration";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2),
    },
    root: {
      maxWidth: 360,
      margin: `${theme.spacing(6)}px auto`,
      padding: theme.spacing(2),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    message: {
      marginTop: theme.spacing(1),
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      width: "100%",
    },
  });

interface NotAuthorizedPageProps extends RouteComponentProps<any>, WithStyles<typeof styles> {}

export const NotAuthorizedPageComponent = (props: NotAuthorizedPageProps) => {
  const { location, history, classes } = props;

  const handleBackClick = () => {
    history.goBack();
  };

  const baseRoleGroupName = getClientConfiguration().sts.baseRoleGroupName;

  const locationState = location.state as { from?: { pathname: string } };

  return (
    <div className={classes.container}>
      <Paper className={classes.root} elevation={4}>
        <Typography className={classes.title} variant="h5">
          Not Authorized
        </Typography>
        {locationState && locationState.from && locationState.from.pathname !== "/" ? (
          <>
            <Typography className={classes.message} component="p">
              You are not authorized to view <code>{locationState.from.pathname}</code>.
            </Typography>
            <Button variant="contained" color="primary" className={classes.button} onClick={handleBackClick}>
              Back
            </Button>
          </>
        ) : (
          <>
            <Typography className={classes.message} component="p">
              You have not yet been authorized to use this application.
            </Typography>
            {baseRoleGroupName ? (
              <Typography className={classes.message} component="p">
                Please contact an administrator, and request that you be assigned to the&nbsp;
                <strong>{baseRoleGroupName}</strong> Active Directory (AD) group.
              </Typography>
            ) : (
              <Typography className={classes.message} component="p">
                Please contact an administrator for assistance.
              </Typography>
            )}
          </>
        )}
      </Paper>
    </div>
  );
};

export const NotAuthorizedPage = withStyles(styles)(NotAuthorizedPageComponent);
